import {gql} from "@apollo/client";

export default gql`
  mutation deleteJob($data: DeleteJobInput!) {
    deleteJob(data: $data)
  }
`;
